import { render } from "./App.vue?vue&type=template&id=927f1d1a&scoped=true&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=927f1d1a&lang=scss"
import "./App.vue?vue&type=style&index=1&id=927f1d1a&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src602189598/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-927f1d1a"]])

export default __exports__